import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {
    Form,
    Row,
    Col,
    Modal,
    message,
    Popconfirm,
    Spin,
    Select,
    Button,
    Icon,
    Table,
    Input,
    InputNumber,
    DatePicker,
    TimePicker,
    Radio,
    Checkbox,
    Calendar,
} from 'antd';
import { connect } from 'react-redux';
import moment from 'moment';
import 'moment/locale/zh-cn';
moment.locale('zh-cn');
import { dateConversion, timeConversion, getDateBetween, showDate } from '../../../utils';
import { getHostList,modifyHost,createHostAction,createStatusAction,bulkUpdate,createBulkStatusAction,createSetIpListAction } from './actions';
const FormItem = Form.Item;
const RadioGroup = Radio.Group;
const CheckboxGroup = Checkbox.Group;
const { TextArea } = Input;

let dataArray = [];
let user = JSON.parse(localStorage.getItem('HippoUserInfo'));
let today = dateConversion(Date.parse(new Date()));
let listData = [];

class BulkUpdate extends Component {
    constructor(props) {
        super(props); // 调用super父类构造函数改变this指向
        this.submit = this.submit.bind(this);
    }
    componentDidMount() {
    }


    // async handleInterstChange(value) {
    //   console.log('aaaa',value);
    // };
    //
    // async handleUserInfoChange(value) {
    //
    // };

    changeAddHide = () => {
        this.props.changeBulkStatus(false);
        this.props.setIpList([]);
        this.props.form.resetFields();
    };

    async submit() {
        this.props.form.validateFields(async (err, fieldsValue) => {
            if (!err) {
                try {
                    const {ipList: hosts} = this.props;
                    let result = {
                        hosts,
                        ...fieldsValue,
                    };
                    await this.props.bulkUpdate(result);
                    await this.props.form.resetFields();
                    await this.changeAddHide();
                    await this.props.GetHostList();
                } catch (err) {
                    console.log(err);
                    alert(err);
                }
            } else {
                console.log(err);
            }
        });
    };
    render() {
        const { getFieldDecorator, onPanelChange } = this.props.form;
        const { status, ipList } = this.props;
        const formItemLayout = {
            labelCol: {
                xs: { span: 18 },
                sm: { span: 6 },
            },
            wrapperCol: {
                xs: { span: 18 },
                sm: { span: 14 },
            },
        };
        const options = ['NORMAL', 'CLICK', 'EV', 'NORMAL_APPOINT', 'APPOINT_CLICK', 'APPOINT_EV'];
        const partnerListOption = options.map(item => <Option value={item}>{item}</Option>);
        return (
            <div>
                <Modal
                    title={'批量修改'}
                    visible={status}
                    onCancel={() => this.changeAddHide()}
                    onOk={() => {
                        this.submit();
                    }}>
                    <Form>
                        <FormItem {...formItemLayout} label="描述">
                            {getFieldDecorator('description', {
                                initialValue: null,
                            })(<Input placeholder="请填入描述" />)}
                        </FormItem>
                        <FormItem {...formItemLayout} label="phantomJS路径">
                            {getFieldDecorator('driverPath', {
                                initialValue: null,
                                rules: [
                                    {
                                        required: false,
                                        message: '请填入phantomJS路径',
                                    },
                                ],
                            })(<Input placeholder="请填入phantomJS路径" />)}
                        </FormItem>
                        <FormItem {...formItemLayout} label="机器分类">
                            {getFieldDecorator('category', {
                                initialValue: null,
                                rules: [
                                    {
                                        required: false,
                                        message: '请选择机器分类',
                                    },
                                ],
                            })(
                                <Select style={{ width: '100%' }} placeholder="请选择机器分类">
                                    {partnerListOption}
                                </Select>,
                            )}
                        </FormItem>
                        <FormItem {...formItemLayout} label="机器分组ID">
                            {getFieldDecorator('groupId', {
                                initialValue: null,
                                rules: [
                                    {
                                        required: false,
                                        message: '请填入机器分组ID',
                                    },
                                ],
                            })(<Input placeholder="请填入机器分组ID" />)}
                        </FormItem>
                        <FormItem {...formItemLayout} label="server IP">
                            {getFieldDecorator('hostIp', {
                                initialValue: null,
                                rules: [
                                    {
                                        required: false,
                                        message: '请填入server IP',
                                    },
                                ],
                            })(<Input placeholder="请填入server IP" />)}
                        </FormItem>
                        <FormItem {...formItemLayout} label="网络">
                            {getFieldDecorator('netName', {
                                initialValue: null,
                                rules: [
                                    {
                                        required: false,
                                        message: '请填入网络',
                                    },
                                ],
                            })(<Input placeholder="请填入网络" />)}
                        </FormItem>
                        <FormItem {...formItemLayout} label="server端口">
                            {getFieldDecorator('port', {
                                initialValue: null,
                                rules: [
                                    {
                                        required: false,
                                        message: '请填入server端口',
                                    },
                                ],
                            })(<Input placeholder="请填入server端口" />)}
                        </FormItem>
                        <FormItem {...formItemLayout} label="并发度">
                            {getFieldDecorator('taskParallel', {
                                initialValue: null,
                                rules: [
                                    {
                                        required: false,
                                        message: '请填入并发度',
                                    },
                                ],
                            })(<Input placeholder="请填入并发度" />)}
                        </FormItem>
                        <FormItem {...formItemLayout} label="超时时间">
                            {getFieldDecorator('waitTimeout', {
                                initialValue: null,
                                rules: [
                                    {
                                        required: false,
                                        message: '请填入超时时间',
                                    },
                                ],
                            })(<Input placeholder="请填入超时时间" />)}
                        </FormItem>
                        <FormItem {...formItemLayout} label="zookeeper路径">
                            {getFieldDecorator('zkPath', {
                                initialValue: null,
                                rules: [
                                    {
                                        required: false,
                                        message: '请填入zookeeper路径',
                                    },
                                ],
                            })(<Input placeholder="请填入zookeeper路径" />)}
                        </FormItem>
                        <FormItem {...formItemLayout} label="点击并发度">
                            {getFieldDecorator('clickTaskParallel', {
                                initialValue: null,
                                rules: [
                                    {
                                        required: false,
                                        message: '请填入点击并发度',
                                    },
                                ],
                            })(<Input placeholder="请填入点击并发度" />)}
                        </FormItem>
                        <FormItem {...formItemLayout} label="曝光并发度">
                            {getFieldDecorator('evTaskParallel', {
                                initialValue: null,
                                rules: [
                                    {
                                        required: false,
                                        message: '请填入曝光并发度',
                                    },
                                ],
                            })(<Input placeholder="请填入曝光并发度" />)}
                        </FormItem>
                    </Form>
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    status: state.hostList.bulkStatus,
    ipList: state.hostList.ipList,
});

const mapDispatchToProps = dispatch => ({
    GetHostList: prarms => dispatch(getHostList()),
    ModifyHost: prarms => dispatch(modifyHost(prarms)),
    bulkUpdate: prarms => dispatch(bulkUpdate(prarms)),
    storeHost: param => dispatch(createHostAction(param)),
    changeStatus: status => dispatch(createStatusAction(status)),
    changeBulkStatus: status => dispatch(createBulkStatusAction(status)),
    setIpList: list => dispatch(createSetIpListAction(list)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Form.create()(BulkUpdate));



// WEBPACK FOOTER //
// ./pages/assist/hostManage/bulkUpdate.js